import { useQueryClient } from '@tanstack/react-query';
import { useOptimisticMutation, type Variables } from '../../../hooks/use-optimistic-mutation';
import type { ShippingMethodApiBase, ShippingMethodApiResponse } from '../types/shipping-method';
import { QK_LIST_SHIPPING_METHODS } from './use-shipping-methods';
import { useShippingMethodsApi } from './use-shipping-methods-api';

export function useCreateShippingMethod() {
  const { shippingMethodsApi } = useShippingMethodsApi();
  const queryClient = useQueryClient();

  async function createMethod(payload: ShippingMethodApiBase) {
    await shippingMethodsApi.create(payload);
  }

  return useOptimisticMutation<ShippingMethodApiResponse[], Variables<typeof createMethod>>({
    mutationFn: createMethod,
    queryKey: QK_LIST_SHIPPING_METHODS(),
    queryClient,
    optimisticUpdate: (prev, newMethod) => {
      const now = new Date().toISOString();

      return [
        ...(prev ?? []),
        // NOTE: set created/updated to the current time for the optimistic update
        // Also set ID to be empty until loaded
        { ...newMethod, id: '', created_at: now, updated_at: now },
      ];
    },
  });
}
